<ng-container [formGroup]="formParent">
  <label [for]="id" [class.required]="required && !hideRequiredLabel">{{
    label | translate
  }}</label>

  <div class="form-field-container">
    <textarea
      [class.resize-forbidden]="!resizable || disabled"
      [formControlName]="name"
      [(ngModel)]="value"
      [placeholder]="placeholder | translate"
      [id]="id"
      [attr.readonly]="readonly"
      [attr.aria-required]="required ? true : null"
      [attr.maxLength]="maxLength ?? undefined"
      [rows]="rows"
    >
    </textarea>
  </div>
  <mat-hint>
    <span *ngIf="maxLength && showCharactersLeft"
      >{{
        "CHARACTERS" | translate: { length: maxLength - (value ?? "").length }
      }}
    </span>
  </mat-hint>

  <mat-error
    id="{{ id }}-required-error"
    *ngIf="ngControl.touched && ngControl?.hasError('required')"
  >
    {{ "REQUIRED" | translate }}
  </mat-error>
  <mat-error
    id="{{ id }}-max-error"
    *ngIf="ngControl.touched && ngControl?.hasError('maxlength')"
  >
    {{
      "MAXLENGHT"
        | translate
          : { requiredLength: ngControl.errors!["maxlength"]["requiredLength"] }
    }}
  </mat-error>
  <mat-error
    id="{{ id }}-min-error"
    *ngIf="ngControl.touched && ngControl?.hasError('minlength')"
  >
    {{
      "MINLENGHT"
        | translate
          : { requiredLength: ngControl.errors!["minlength"]["requiredLength"] }
    }}
  </mat-error>
</ng-container>
